// extracted by mini-css-extract-plugin
export default {"tab":"GWbSa","tabActive":"FXVtx","icon":"hGH0x","text":"mEkKY","count":"V187_"};